import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { Socket } from 'socket.io-client';

import { clientConfig } from '@/config/clientConfig';

import { useSocketConnection } from './useSocketConnection';

const AuthSocketContext = createContext<Socket | null>(null);

export const useAuthSocket = () => {
  return useContext(AuthSocketContext);
};

export const AuthSocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const socket = useSocketConnection({
    url: clientConfig.socketUrls.auth,
    namespace: 'Auth',
  });

  return <AuthSocketContext.Provider value={socket}>{children}</AuthSocketContext.Provider>;
};
